/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { connect } from "react-redux";
import { setLanguage } from "actions";
import "components/widgets/language/language.css";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";

class LanguageSelectorMobile extends Component {
  changeLanguage = (lang) => {
    this.props.setLanguage(lang);
  };

  getLanguage = () => {
    switch (this.props.language) {
      case "tr-TR":
        return "TRK";
      case "en-US":
        return "ENG";
      case "ar-AE":
        return "ARA";
      case "fr-FR":
        return "FRA";
      case "de-DE":
        return "DEU";
      case "ru-RU":
        return "RUS";
      case "es-ES":
        return "ESP";
      default:
        return "ENG";
    }
  };
  render() {
    return (
      <div className="col-md-12">
        <ul className="submenu langMenu">
          <li>
            <a href="#" onClick={() => this.changeLanguage("ar-AE")}>
              <UAEFlag className="img-fluid flag" /> Arabic
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("en-US")}>
              <UKFlag className="img-fluid flag" /> English
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("fr-FR")}>
              <FRFlag className="img-fluid flag" /> French
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("de-DE")}>
              <DEFlag className="img-fluid flag" /> German
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("ru-RU")}>
              <RUFlag className="img-fluid flag" /> Russian
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("es-ES")}>
              <ESFlag className="img-fluid flag" /> Spanish
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage("tr-TR")}>
              <TRFlag className="img-fluid flag" /> Turkish
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.application.language,
  };
};

export default connect(mapStateToProps, { setLanguage })(
  LanguageSelectorMobile
);
